import { Tooltip, IconButton, TableCell } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import { Link } from 'react-router-dom';

function TableRowVizsgaFeladatButton(props) {
	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title="Feladatok">
				<IconButton component={Link} to={`/vizsga-feladat/${props.item.id}`} disabled={props.item.csoport !== 0}>
					<ListIcon fontSize="small" />
				</IconButton>
			</Tooltip>
		</TableCell>
	);
}

export default TableRowVizsgaFeladatButton;
